import { render, staticRenderFns } from "./GoldForm.vue?vue&type=template&id=8ae6b704"
import script from "./GoldForm.vue?vue&type=script&lang=js"
export * from "./GoldForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports